import request from '../../axios';

export const getSubBrandDetailById = async (subBrandId?: string) => {
  const {data}: {data: ISubBrand} = await request.get(
    `/api/v2/warehouse/brand/sub-brand/` + subBrandId,
  );

  return data;
};
